
<template>
  <b-modal
      :title="_.get(memberRecord, 'muser.fullName')"
      header-bg-variant="success"
      header-text-variant="light"
      size="lg"
      :visible="showModal"
      centered
      @hidden="reset"
    >

    <b-row>
      <h2 v-show="updateUserMembershipPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
      <pulse-loader :loading="updateUserMembershipPending" :color="spinnerColor" :size="spinnerSize"></pulse-loader>
    </b-row>

    <b-row v-if="!updateUserMembershipPending">
      <b-col>
        <b-form>
        <b>Memberships: </b><div v-if="memberRecord !== undefined">  {{ memberRecord.morganization.title}} </div>

          <!-- ORG ADMIN - Give the option to turn OrgAdmin priviledges OFF -->
          <b-form-checkbox
            id="isOrgAdminOff"
            v-model="selectedOrgAdmin"
            name="isOrgAdminOff"
            unchecked-value="false"
            switch
            incline
            class="m-3"
            >
            Organization Administrator: Would you like for this user to be able to share, unshare and transfer records?
          </b-form-checkbox>

          <!-- ORG MANAGER - Give the option to turn Org Manager priviledges OFF -->
          <b-form-checkbox
            id="isOrgManagerOff"
            v-model="selectedOrgManager"
            name="isOrgManagerOff"
            :unchecked-value="false"
            switch
            incline
            class="m-3"
            >
            Organization Manager: Would you like this user to be able to view all of the records for your organization?
          </b-form-checkbox>

          <b-form-checkbox
            id="isOrgDWUserOff"
            v-model="selectedOrgDWUser"
            name="isOrgDWUserOff"
            :unchecked-value="false"
            switch
            inline
            class="m-3">
              Data Warehouse User: Would you like this user to be able to access the Lighthouse Data Warehouse application?
          </b-form-checkbox>

          <b-form-checkbox
            id="isOrgCareCoordinatorOff"
            v-model="selectedOrgCareCoordinator"
            name="isOrgCareCoordinatorOff"
            :unchecked-value="false"
            switch
            inline
            class="m-3">
            Care Coordinator: Would you like this user to access the Victim Identification tab designed for care coordinators?
          </b-form-checkbox>
        </b-form>
      </b-col>
      <b-col>
        <br>
        <b>Created At: </b> {{ $moment.unix(_.get(memberRecord, 'createdAt', 1000) / 1000).format("MM/DD/YYYY") }}
          <div v-if="_.isObject(memberRecord.createdBy)">
            <b> by: </b> {{ _.get(memberRecord, 'createdBy.emailAddress', '') }}
          </div>
        <br>
        <b>Last Updated: </b> {{ $moment.unix(_.get(memberRecord, 'updatedAt', 1000) / 1000).format("MM/DD/YYYY") }}
          <div v-if="_.isObject(memberRecord.updatedBy)">
            <b> by: </b> {{ _.get(memberRecord, 'updatedBy.emailAddress', '') }}
          </div>
        <br>
      </b-col>
    </b-row>

    <b-alert
      dismissible
      fade
      :show="updateUserMembershipFailure || _.isObject(updateUserMembershipSuccess)"
      :variant="updateUserMembershipFailure ? 'danger' : 'success'"
    >
      <span v-html="apiResponseMessage()"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <b-button
          v-if="!disableDelete"
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-left"
          @click="userMemberHandlerDelete"
      >
        <span class="button-text">Delete</span>
      </b-button>
      <span v-else class="text-danger"> This is the primary organization for this user.  It cannot be removed.  </span>
      <b-button
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-right"
          @click="userMemberHandler"
      >
        <span class="button-text">Update</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'update-user-member-modal',
  props: {
    userId: Number,
    memberRecord: Object,
    showModal: Boolean,
    disableDelete: Boolean
  },
  components: {
  },
  data: function () {
    return {
      selectedOrgAdmin: this.memberRecord.isOrgAdmin,
      selectedOrgManager: this.memberRecord.isManager,
      selectedOrgDWUser: this.memberRecord.isDWUser,
      selectedOrgCareCoordinator: this.memberRecord.isCareCoordinator,
      spinnerColor: '#489AAC',
      spinnerSize: '50px'
    }
  },
  watch: {
    updateUserMembershipSuccess: function (newValue) {
      if (this.showModal) {
        _.delay(this.reset, 1000)
      }
    },
    showModal (newValue) {
      if (newValue) {
        this.selectedOrgAdmin = this.memberRecord.isOrgAdmin
        this.selectedOrgManager = this.memberRecord.isManager
        this.selectedOrgDWUser = this.memberRecord.isDWUser
        this.selectedOrgCareCoordinator = this.memberRecord.isCareCoordinator
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getViewUser',
      updateUserMembershipPending: 'updateUserMembershipPending',
      updateUserMembershipSuccess: 'updateUserMembershipSuccess',
      updateUserMembershipFailure: 'updateUserMembershipFailure'
    }),
    isOrgAdmin: function () {
      return _.get(this.memberRecord, 'orgAdmin', false)
    },
    isManager: function () {
      return _.get(this.memberRecord, 'orgManager', false)
    }
  },
  methods: {
    userMemberHandler: function () {
      const isOrgAdmin = this.selectedOrgAdmin
      const isManager = this.selectedOrgManager
      const isDWUser = this.selectedOrgDWUser
      const isCareCoordinator = this.selectedOrgCareCoordinator

      if (!this.userId) {
        this.$store.commit('SET_USERMEMBER_STATE', {
          field: 'updateUserMembershipFailure',
          value: { success: false, error: { code: 'INVALID_API_CALL', message: 'Incorrect parameters' } }
        })
      }
      if (this.userId && this.memberRecord.morganization.id) {
        // console.log({
        //   muser: this.userId,
        //   morganization: this.memberRecord.morganization.id,
        //   isOrgAdmin: isOrgAdmin,
        //   isManager: isManager})
        this.$store.dispatch('updateUserMembership', {
          id: this.memberRecord.id,
          morganization: this.memberRecord.morganization,
          data: {
            muser: this.userId,
            morganization: this.memberRecord.morganization.id,
            isOrgAdmin: isOrgAdmin,
            isManager: isManager,
            isDWUser: isDWUser,
            isCareCoordinator
          }
        })
      }
    },
    userMemberHandlerDelete: function () {
      if (this.userId && this.memberRecord) {
        this.$store.dispatch('deleteUserMembership', {
          id: this.memberRecord.id
        })
      }
    },
    apiResponseMessage: function () {
      let message = ''
      if (this.updateUserMembershipSuccess) {
        message = 'Success!'
      }

      if (this.updateUserMembershipFailure) {
        message = this.$utils.errorToHtml(this.updateUserMembershipFailure)
      }

      return '<p>' + message + '</p>'
    },
    reset: function () {
      this.$store.commit('RESET_UPDATE_USERMEMBER')
      this.$emit('update:showModal', false)
    }
  },
  beforeDestroy () {
    this.reset()
  }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/Admin/UpdateUserMemberModal.vue